module.exports = __webpack_public_path__ + "static/parade-2020-house07-4323e8afee76b57c36b234f975c1ff76.jpg";